// ./src/store/actions
import axios from 'axios';
import myHttpApi from "../api/myhttpapi";

const API_BASE = 'https://api/v1/';

import {
  ADD_PRODUCT,
  ADD_PRODUCT_SUCCESS,
  PRODUCT_BY_ID,
  PRODUCT_BY_ID_SUCCESS,
  UPDATE_PRODUCT,
  UPDATE_PRODUCT_SUCCESS,
  REMOVE_PRODUCT,
  REMOVE_PRODUCT_SUCCESS,
  ALL_PRODUCTS,
  ALL_PRODUCTS_SUCCESS,
  ALL_MANUFACTURERS,
  ALL_MANUFACTURERS_SUCCESS,
  ALL_CATEGORIES,
  ALL_CATEGORIES_SUCCESS,
  ALL_CALENDARS,
  ALL_CALENDARS_SUCCESS
} from './mutation-types';


export const productActions = {
  getServiceUsers ({commit}, product) {
    commit(ALL_USERS_FORSERVICE)

    const searchRec = {Search: product.ArticleID, Extra: ""}
    myHttpApi.post( 'Service/ServiceUsers', searchRec)
        .then(response => {
          commit(ALL_USERS_FORSERVICE_SUCCESS, response.data)
        })
        .catch(error => {
          console.log(error);
    });
  },
  allProducts ({commit}) {
    commit(ALL_PRODUCTS)
    // Fetch actual products from the API
    axios.get(`${API_BASE}/products`).then(response => {
      commit(ALL_PRODUCTS_SUCCESS, response.data)
    })
  },
  productById ({commit}, payload) {
    commit(PRODUCT_BY_ID)
    // Fetch product by ID from API
    axios.get(`${API_BASE}/products/${payload}`).then(response => {
      commit(PRODUCT_BY_ID_SUCCESS, response.data)
    })
  },
  addProduct ({commit}, payload) {
    commit(ADD_PRODUCT)
    // Create a new product via API
    axios.post(`${API_BASE}/products`, payload).then(response => {
      commit(ADD_PRODUCT_SUCCESS, response.data)
    })
  },
  updateProduct ({commit}, payload) {
    commit(UPDATE_PRODUCT)
    // Update product via API
    axios.put(`${API_BASE}/products/${payload._id}`, payload).then(response => {
      commit(UPDATE_PRODUCT_SUCCESS, response.data)
    })
  },
  removeProduct ({commit}, payload) {
    commit(REMOVE_PRODUCT)
    // Delete product via API
    axios.delete(`${API_BASE}/products/${payload}`, payload).then(response => {
      console.debug('response', response.data)
      commit(REMOVE_PRODUCT_SUCCESS, response.data)
    })
  },
  allCategories ({commit}) {
    commit(ALL_CATEGORIES)
    myHttpApi

    const searchRec = {Search: "", Extra: ""}
    myHttpApi.post( 'Service/GetCategories', searchRec)
        .then(response => {
          commit(ALL_CATEGORIES_SUCCESS, response.data)
        })
        .catch(error => {
          console.log(error);
        });
  },
  allCalendars ({commit}) {
    commit(ALL_CALENDARS)
    myHttpApi
    myHttpApi.post( 'Settings/GetCalendars')
        .then(response => {
          commit(ALL_CALENDARS_SUCCESS, response.data)
        })
        .catch(error => {
          console.log(error);
        });
  },
};

export const manufacturerActions = {
  allManufacturers ({commit}) {
    commit(ALL_MANUFACTURERS)
    // Fetch all manufacturers from API
    axios.get(`${API_BASE}/manufacturers`).then(response => {
      commit(ALL_MANUFACTURERS_SUCCESS, response.data)
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js